export const snackbarMessages = {
  addToBatchError: "Couldn't add job to the selected batch, please try again",
  addToExistingProjectError: "Couldn't add to project, please try again",
  addToExistingProjectSuccess: 'Added to project successfully',
  addToNewProjectError: "Project created, but couldn't add this job to it",
  addToNewProjectSuccess: 'Project created and job added to it',
  approvalFailed: 'Failed to approve the job',
  archived: 'Archived',
  archiveFailed: 'Failed to archive the job',
  attachedForm: 'Form attached to the job',
  attachedFormRequirement: 'Form attached to the job',
  attachFormError: 'Failed to attach form to the job',
  attachFormRequirement: 'Form attached to the job',
  attachFormRequirementError: 'Failed to attach form to the job',
  approved: 'Job approved',
  bulkCreateLimitError: 'Please reduce the number of jobs to create',
  bulkCreateNoDateError: 'Please select at least one date',
  bulkCreateSaveError: 'Failed to create job(s)',
  cancelApprovalRequest: 'Successfully cancel approval request',
  cancelApprovalRequestFailed: 'Failed to cancel approval request',
  clone: 'Job cloned',
  cloneFollowUpJobsDisabled: 'Follow-up jobs were turned off',
  detailsUpdated: 'Job details has been updated',
  errorFetchingJobHistory: 'Failed to fetch job history',
  errorUploadingAttachment: 'Failed to upload attachment',
  failedToSubmitComment: 'Failed to submit comment',
  failedToFetchSchema: 'Unable to load activity fields',
  fetchJobRequestError: 'Failed to fetch job request',
  genericError: 'Failed to save job',
  grantLocationsToHubError: 'Cannot grant locations to hub',
  ironSightFormsNotAllFilled: 'All forms must be filled out before completing the job',
  jobAddedToBatch: 'Job added to the selected batch',
  jobAddedToBatchFailure: 'Cannot add job to the selected batch',
  locationsInventoryUpdated: 'Job locations/inventory have been updated',
  notificationSent: 'Notifications sent',
  pdfDownloadError: 'Failed to download PDF',
  plannedOrActualTimesUpdated: 'Job planned/actual times have been updated',
  rejected: 'Job approval rejected',
  removeJobFromBatchError: 'Failed to remove job from batch',
  removeJobFromBatchSuccess: 'Successfully removed job from batch',
  removeJobFromGroupError: 'Failed to remove job from group',
  removeJobFromProjectError: 'Failed to remove job from project',
  removedJobFromBatch: 'Job removed from batch',
  removedJobFromBatchFailure: 'Fail to remove job from batch',
  removedJobFromGroup: 'Job removed from group',
  saved: 'Job saved',
  signatureAdded: 'Signature added',
  signatureCleared: 'Signature cleared',
  statusUpdated: 'Status updated',
  submitForApprovalFailed: 'Failed to submit job for approval',
  submittedForApproval: 'Job submitted for approval',
  tagsUpdated: 'Tags have been updated',
  unapprovalFailed: 'Failed to unapprove the job',
  unapproved: 'Job unapproved',
  unarchiveFailed: 'Failed to unarchive the job',
  unarchived: 'Unarchived',
  unCompleteJobRequest: 'Job reopened',
  unCompleteJobRequestFailed: 'Failed to reopen job',
  unsupportedAttachmentSize: 'File size must be under 25 MB',
  unsupportedAttachmentType: 'This file type is not supported',
  updatedAttachedFormSubmission: 'Form submission has been updated',
  updatedFormRequirementSubmission: 'Form submission has been updated',
  updateRepeatJobsCountError: 'Failed to update repeat jobs count',
  validationError: 'Please correct the errors on the form',
  versionUpdate: 'Custom fields updated. Check before saving.',
}
